<template>
    <b-form-input
    v-on:keyup="changeValues"
    @keydown.enter.native="enterEvent"
    :type="inputFocus?'number' : 'text'"
    @focus="onFocus"
    @blur="onBlur"
    pattern="\d*"
    :formatter="avoidDecimal"
    ref="inputField"
    v-model.lazy="myModel"
    placeholder="Enter a value" />
</template>
<script>
 export default {
    props: ['model','name'],
    data() {
        return {  
            inputFocus:false,
            myModel:''
        }
    },
    watch:{
        model() {
            this.myModel = this.model; 
        }
    },
    methods:{            
        avoidDecimal(value){
                if(value)
                    return Math.round(value);
                else
                    return value
        },
        focus(){
            console.log('dsds')
            this.$refs.inputField.focus()
        },
        enterEvent(){
            this.$emit('enterEvent', 'enter')
        },
        changeValues(){
            this.$emit('changeValue', this.myModel, this.name)
        },
        onFocus(){
            this.inputFocus=  true
            this.myModel = this.myModel?  this.unmaskMoneyValue(this.myModel) : this.myModel
        },
        onBlur(){
            this.inputFocus=  false
            this.myModel = this.myModel ? `$${this.numberWithCommas(this.myModel)}` : ''
        },
        unmaskMoneyValue(val) {
            return val.replace("$", "").replace(",", "");
        },
        numberWithCommas(x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
    }
 }
</script>
